<div *ngIf="!onInventory">
  <div *ngIf="equipmentDetails=== undefined || equipmentDetails === null"
    style="   margin-left: 40%; margin-top:20px; margin-bottom: 20px;">
    <mat-spinner></mat-spinner>
  </div>
</div>

<div style="margin:5px; background-color: #F5F8FB; padding: 24px;" class="panel"
  *ngIf="equipmentDetails != null && !onInventory">
  <div class="panel__header">
    <span class="panel__header__title">
      {{"Equipment Details" | translate | async}}
    </span>
  </div>
  <div class="panel__content flex flex--align-center">
    <div class="overall-eval-container">
      <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
      <div class="bold  margin-r--24 {{getEvalClass(equipmentDetails.PercentWorn)}}"
        style=" font-size: 65px; border-radius: 4px;color: white;">
        {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
      </div>
    </div>
    <div class="column-container flex-grow">
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{"Customer" | translate | async}}
          </span>
          <span class="text-block__important">
            {{equipmentDetails.CustomerName}}
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{"Job Site" | translate | async}}
          </span>
          <span class="text-block__important">
            {{equipmentDetails.JobsiteName}}
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{"Serial Number" | translate | async}}
          </span>
          <span class="text-block__important">
            <a routerLink="/get-equipment/{{equipmentDetails.equipmentId}}" title="Go to Equipment View">
              {{equipmentDetails.SerialNumber}}
            </a>
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{"Unit Number" | translate | async}}
          </span>
          <span class="text-block__important">
            <a routerLink="/get-equipment/{{equipmentDetails.equipmentId}}" title="Go to Equipment View">
              {{equipmentDetails.UnitNumber}}
            </a>
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{"Asset Serial Number" | translate | async}}
          </span>
          <span class="text-block__important">
            <a routerLink="/implementdetails/{{AssetDetail.GETAuto}}" title="Go to Implement View">
              {{AssetDetail.AssetSerial}}
            </a>
          </span>
        </div>
        <div class="text-block">
          
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{"Last Inspection Date" | translate | async}}
          </span>
          <span class="text-block__important">
            {{equipmentDetails.LastInspectionDate}}
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{"Next Inspection Date" | translate | async}}
          </span>
          <span class="text-block__important">
            {{ equipmentDetails.NextInspectionDate }}
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{"Meter Reading (SMU)" | translate | async}}
          </span>
          <span class="text-block__important">
            {{equipmentDetails.Smu}}
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{"Life to Date (LTD)" | translate | async}}
          </span>
          <span class="text-block__important">
            {{equipmentDetails.Ltd}}
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{"Make" | translate | async}}
          </span>
          <span class="text-block__important">
            {{equipmentDetails.Make}}
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{"Model" | translate | async}}
          </span>
          <span class="text-block__important">
            {{equipmentDetails.Model}}
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{"Family" | translate | async}}
          </span>
          <span class="text-block__important">
            {{equipmentDetails.Family}}
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{"Setup Date" | translate | async}}
          </span>
          <span class="text-block__important">
            {{equipmentDetails.EquipmentSetupDate}}
          </span>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="refresh-button">
  <div>
    <button style="float:right;" mat-raised-button color="warn" (click)="RefreshReportOption()">
      {{"Refresh with Asset Type Report Options" | translate | async}}
      <i class="material-icons">refresh</i>
    </button>
  </div>
  <div style="width: 227px;">
    <button style="float:right;" mat-raised-button color="warn" (click)="RefreshInspectionData()">
      {{"ReCalculate Inspection" | translate | async}}
      <i class="material-icons">refresh</i>
    </button>
  </div>

</div>


<div style="padding: 24px;">

  <div>
    <mat-tab-group [(selectedIndex)]="selectedTab" (selectedIndexChange)="LoadData(selectedTab)">
      <mat-tab label="{{'Inspection' | translate | async}}" style="font-size: large;color: black;">


        <mat-card *ngIf="!loading && selectedTab == 0">
          <div *ngFor="let implementToBeInspected of inspectedImplements" style="background-color: white;">
            <implement-inspection-section [isCreatingInspection]="false" 
              [implementToBeInspected]="implementToBeInspected" (updateObs)="LoadPageAgain()">
            </implement-inspection-section>
          </div>
        </mat-card>
      </mat-tab>


      <mat-tab label="{{'Report Configuration' | translate | async}}" style="font-size: large;color: black;">
        <mat-card *ngIf="!loading && selectedTab == 1">
          <div class="asset-button">
              <div>
                <p style="font-size: 23px; padding-top: 8px; padding-right: 20px;"><strong> {{AssetDetail.AssetName}} </strong></p>
              </div>
              <div>
                <button mat-raised-button color="warn" (click)="FillComponentTypeReportConfigurations()">{{"Save Report Configuration At Asset Type" | translate | async}}</button>
              </div>
          </div>

          <ul *ngFor="let item of TypesList" style="background-color: white;">

            <div style="display: flex; flex-direction: row;justify-content: flex-end;">
              <div><span title="Move up" style="margin-right: 16px!important; cursor: pointer;"
                  [class.button-hide]="item.group_order==0?true:false"
                  (click)="recalculateSortOrderUp(item.group_order)">
                  <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_upward</i>
                </span>
              </div>
              <div><span title="Move down" style="margin-right: 16px!important;cursor: pointer;"
                  [class.button-hide]="item.group_order==TypesList.length-1?true:false"
                  (click)="recalculateSortOrderDown(item.group_order)">
                  <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_downward</i>
                </span></div>
            </div>
            <div>
              <li class="dropzone" draggable="true" (dragstart)="drag($event)" (drop)="drop($event)"
                (dragover)="allowDrop($event)" attr.id="{{item.group_order}}" style="border-style: solid; border-width: 1px;padding-top: 12px;
              padding-right: 12px;
              padding-bottom: 12px;
              padding-left: 12px;">

                <div style="    display: flex; flex-direction: row;">
                  <div (drop)="drop($event)" (dragover)="allowDrop($event)"
                    style="display: flex; flex-direction: column;" class="dropzone_child">
                    <div>
                      <span class="component-type" style="font-size: 18px;"> <b> {{item.ComponentTypeName}} </b>
                      </span>
                    </div>
                    <div>
                      <input matInput type='text' [placeholder]="'Alternate Group Name' | translate | async" style="font-size: 14px;"
                        [(ngModel)]="item.AlterGroupName" class="get-Input"
                        (change)="GroupTypeNameChanged(item.Id,item.AlterGroupName)">
                    </div>
                  </div>


                  <div (drop)="drop($event)" (dragover)="allowDrop($event)"
                    style="display: flex; flex-direction: column;margin-left: 5%;    width: 40%;"
                    class="dropzone_child">
                    <div>
                      <span class="component-type" style="font-size: 18px;"> <b> {{"Include in Report Summary" | translate | async}} </b>
                      </span>
                    </div>
                    <div style="display: flex; flex-direction: row;margin-top: 1%;">
                      <div style="margin-top: 11px;">
                        <span class="component-flag">
                          <b>
                            <mat-checkbox style="padding-right: 8px;" [checked]="item?.IncludeSummary"
                              (change)="toggleIncludeSummary(item.Id)"><span class="label-reportoption">{{"Include Graph in Summary" | translate | async}}</span>
                            </mat-checkbox>
                          </b>
                        </span>
                      </div>


                      <div style="margin-left: 20%;">
                        <span class="component-group label-reportoption">
                          <b> {{"Summary Eval" | translate | async}}: </b>
                        </span>
                        <span>
                          <b>
                            <mat-form-field class="report-eval">

                              <mat-select #nameEval [(ngModel)]="item.Eval"
                                (selectionChange)="ChangeReportEvalOption(item.Id,$event)">
                                <mat-option [value]="0">U</mat-option>
                                <mat-option [value]="1">A</mat-option>
                                <mat-option [value]="2">B</mat-option>
                                <mat-option [value]="3">C</mat-option>
                                <mat-option [value]="4">X</mat-option>

                              </mat-select>
                            </mat-form-field>
                          </b>
                        </span>

                      </div>
                    </div>
                    <div style="display: flex; flex-direction: row;margin-top: 1%;">
                      <div style="margin-top: 11px;">
                        <span class="component-flag">
                          <b>
                            <mat-checkbox style="padding-right: 8px;" [checked]="item?.IncludeSchematicInSummary"
                              (change)="toggleIncludeSchematicInSummary(item.Id,$event,item)"><span
                                class="label-reportoption">{{"Include Schematic in Summary" | translate | async}}</span>
                            </mat-checkbox>
                          </b>
                        </span>


                      </div>

                      <div style="margin-left: 14%;" *ngIf="item.ShowImageRotation || item.IncludeSchematicInSummary">
                        <span class="component-group label-reportoption">
                          <b> {{"Image Rotation" | translate | async}}: </b>
                        </span>
                        <span>
                          <b>
                            <mat-form-field class="report-eval">

                              <mat-select #nameEval [(ngModel)]="item.ImageRotationId"
                                (selectionChange)="ChangeReportImageRotationOption(item.Id,$event)">

                                <mat-option [value]="rotation.Id" *ngFor="let rotation of ImageRotationsList">
                                  {{rotation.Name}}
                                </mat-option>

                              </mat-select>
                            </mat-form-field>
                          </b>
                        </span>

                      </div>
                    </div>

                    <div>
                      <span class="component-group label-reportoption">
                        <b> {{"Summary Comment" | translate | async}} </b>
                        <span>
                          <!-- <textarea class="textarea-reportoption" [(ngModel)]="item.Comment"></textarea> -->

                          <textarea class="textarea-reportoption textAreaComment" rows="4" maxlength="256"
                            [(ngModel)]="item.Comment" (change)="commentChanged(item.Id,item.Comment)"
                            [placeholder]="'Enter a Summary Comment.' | translate | async"></textarea>
                        </span>
                      </span>
                    </div>
                  </div>


                  <div (drop)="drop($event)" (dragover)="allowDrop($event)"
                    style="display: flex; flex-direction: column;margin-left: 5%; " class="dropzone_child">
                    <div>
                      <span class="component-type" style="font-size: 18px;"> <b> {{"Include in Report Body" | translate | async}} </b>
                      </span>
                    </div>
                    <div style="margin-top: 11px;">
                      <span class="component-flag">
                        <b>
                          <mat-checkbox style="padding-right: 8px;" [checked]="item?.IncludeInBody"
                            (change)="toggleIncludeBody(item.Id)"><span class="label-reportoption">{{"Include in Report Body" | translate | async}}</span>
                          </mat-checkbox>
                        </b>
                      </span>
                    </div>

                    <div style="margin-top: 11px;">
                      <span class="component-flag">
                        <b>
                          <mat-checkbox style="padding-right: 8px;" [checked]="item?.IncludeDataTable"
                            (change)="toggleIncludeTable(item.Id)"><span class="label-reportoption">{{"Include Data Table" | translate | async}}</span>
                          </mat-checkbox>
                        </b>
                      </span>
                    </div>

                    <div style="margin-top: 6%; display: flex;">
                      <span class="component-flag">
                        <b>
                          <mat-checkbox style="padding-right: 8px;" [checked]="item?.IncludeGraph"
                            (change)="toggleIncludeGraph(item.Id)"><span class="label-reportoption">{{"Include Graph" | translate | async}}</span>
                          </mat-checkbox>
                        </b>
                      </span>

                      <span class="component-flag" *ngIf="item.IncludeGraph==true" style="margin-top: -2%;">
                        <b>
                          <mat-radio-group class="report-radio-group" [(ngModel)]="item.ChartType"
                            (change)="UpdatechartType(item.Id,item.ChartType)"
                            style="    margin-block-start: auto;margin-left: 52%;">
                            <mat-radio-button [value]="1">{{ 'Pie Chart' | translate | async }}</mat-radio-button>
                            <mat-radio-button [value]="2">{{ 'Bar Chart' | translate | async }}</mat-radio-button>
                            <mat-radio-button [value]="3">{{ 'Speedometer Chart' | translate | async }}</mat-radio-button>
                          </mat-radio-group>
                        </b>
                      </span>
                    </div>

                  </div>

                </div>

              </li>
            </div>
          </ul>
        </mat-card>
      </mat-tab>

      <mat-tab *ngIf="false" label="{{'Tray Report Configuration' | translate | async}}" style="font-size: large;color: black;">
        <mat-card *ngIf="!loading && selectedTab == 2">
          <div style="display: flex;">
            <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{"Wear Package Status" | translate | async}}</h4>
            <div style="display: flex; flex-direction: row; margin-left: 3%; align-items: center;">
              <section class="example-section">
                <mat-checkbox class="example-margin" [(ngModel)]="None"
                  (change)="changeCheckbox('None')">{{'None'}}</mat-checkbox>
                <mat-checkbox class="example-margin" [(ngModel)]="Stage_1" (change)="changeCheckbox('Stage_1')">{{'Stage 1'}}</mat-checkbox>
                <mat-checkbox class="example-margin" [(ngModel)]="Stage_2" (change)="changeCheckbox('Stage_2')">{{'Stage 2'}}</mat-checkbox>
                <mat-checkbox class="example-margin" [(ngModel)]="Stage_3" (change)="changeCheckbox('Stage_3')">{{'Stage 3'}}</mat-checkbox>
                <mat-checkbox class="example-margin" [(ngModel)]="Stage_4" (change)="changeCheckbox('Stage_4')">{{'Stage 4'}}</mat-checkbox>
              </section>
              <button style="margin-left: 20px;    height: fit-content;" class="button button--primary"
                (click)="UpdateWearStatusFiled()"><span class="button__text">{{"Update" | translate | async}}</span></button>

              <button style="margin-left: 50px;    height: fit-content;" class="button button--primary"
                (click)="GenerateTrayPDF()"><span class="button__text">{{"Generate PDF" | translate | async}}</span></button>
            </div>



          </div>

          <ul *ngFor="let item of TypesList" style="background-color: white;">

            <div style="display: flex; flex-direction: row;justify-content: flex-end;">
              <div><span title="Move up" style="margin-right: 16px!important; cursor: pointer;"
                  [class.button-hide]="item.group_order==0?true:false"
                  (click)="recalculateSortOrderUp(item.group_order)">
                  <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_upward</i>
                </span>
              </div>
              <div><span title="Move down" style="margin-right: 16px!important;cursor: pointer;"
                  [class.button-hide]="item.group_order==TypesList.length-1?true:false"
                  (click)="recalculateSortOrderDown(item.group_order)">
                  <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_downward</i>
                </span></div>
            </div>
            <div>
              <li class="dropzone" draggable="true" (dragstart)="drag($event)" (drop)="drop($event)"
                (dragover)="allowDrop($event)" attr.id="{{item.group_order}}" style="border-style: solid; border-width: 1px;padding-top: 12px;
              padding-right: 12px;
              padding-bottom: 12px;
              padding-left: 12px;">

                <div style="    display: flex; flex-direction: row;">
                  <div (drop)="drop($event)" (dragover)="allowDrop($event)"
                    style="display: flex; flex-direction: column;" class="dropzone_child">
                    <div>
                      <span class="component-type" style="font-size: 18px;"> <b> {{item.ComponentTypeName}} </b>
                      </span>
                    </div>
                    <div>
                      <input matInput type='text' [placeholder]="'Alternate Group Name' | translate | async" style="font-size: 14px;"
                        [(ngModel)]="item.AlterGroupName" class="get-Input"
                        (change)="GroupTypeNameChanged(item.Id,item.AlterGroupName)">
                    </div>
                  </div>


                  <div (drop)="drop($event)" (dragover)="allowDrop($event)"
                    style="display: flex; flex-direction: column;margin-left: 5%;    width: 40%;"
                    class="dropzone_child">




                    <div style="display: flex; ">
                      <span class="component-group label-reportoption" style="width: 45%; align-self: center;">
                        <b> {{"General Condition" | translate | async}} </b>
                      </span>

                      <textarea class="textarea-reportoption textAreaComment" rows="1" maxlength="256"
                        [(ngModel)]="item.GeneralComment" (change)="GeneralcommentChanged(item.Id,item.GeneralComment)"
                        placeholder="{{'Enter General Condition' | translate | async}}"></textarea>


                    </div>

                    <div style="display: flex; ">
                      <span class="component-group label-reportoption" style="width: 45%; align-self: center;">
                        <b> {{"Repair Recommendations" | translate | async}} </b>
                      </span>
                      <textarea class="textarea-reportoption textAreaComment" rows="1" maxlength="256"
                        [(ngModel)]="item.RepairComment" (change)="RepaircommentChanged(item.Id,item.RepairComment)"
                        placeholder="{{'Enter Repair Recommendations' | translate | async}}"></textarea>
                    </div>
                  </div>



                </div>


              </li>
            </div>




          </ul>

        </mat-card>
      </mat-tab>
      <mat-tab label="{{'Pre-Inspection Checklist' | translate | async}}" style="font-size: large;color: black;">
        <mat-card *ngIf="!loading && selectedTab == 2">
          <app-pre-inspection-checklist [inspectionID]="inspectionID">
          </app-pre-inspection-checklist>
        </mat-card>
      </mat-tab>

    </mat-tab-group>
  </div>

</div>
